/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { Game, GameState, ActiveAddonExtension } from './types';
import { getDefaultErrorState, getDefaultLoadingState, getDefaultState } from '../utils';
import { GetModResponse, ModTagGroup } from '@c/landingpage/modpack/types';
import { MutationRequestStatus } from '../types';
import { createWorker } from './game.workerfactory';

export const mutations: MutationTree<GameState> = {
  gameLoading(state) {
    state.game = { ...getDefaultLoadingState() };
  },
  gameLoaded(state, payload: Game) {
    state.game = {
      ...getDefaultState(),
      data: payload,
      status: MutationRequestStatus.SUCCESS,
    };
  },
  gameError(state) {
    state.game = { ...getDefaultErrorState() };
  },
  modsLoading(state) {
    state.mods = {
      ...getDefaultLoadingState(),
    };
  },
  modsLoaded(state, payload: GetModResponse) {
    state.mods = {
      ...getDefaultState(),
      data: payload,
      status: MutationRequestStatus.SUCCESS,
    };
  },
  modsError: (state) => {
    state.mods = { ...getDefaultErrorState() };
  },
  createWorker: (state) => {
    if (state.worker == null) {
      state.worker = createWorker();
    }
  },
  resetWorker: (state) => {
    state.worker = null;
  },
  modsGrouped(state, payload: Array<ModTagGroup>) {
    state.groupedMods = {
      ...getDefaultState(),
      data: payload,
      status: MutationRequestStatus.SUCCESS,
    };
  },

  /**
   * mutators for available extensions
   * @param state
   */
  availableModspaceAddonsLoading: (state) => state.extensions = { ...getDefaultLoadingState() },
  availableModspaceAddonsLoaded: (state, payload) => state.extensions = {
    status: MutationRequestStatus.SUCCESS,
    data: payload,
    error: undefined,
  },
  availableModspaceAddonsFailure: (state) => state.extensions = { ...getDefaultLoadingState() },

  activeModspaceAddonLoading: (state) => state.activeModspaceExtension = {
    ...getDefaultLoadingState(),
  },
  activeModspaceAddonFailure: (state) => state.activeModspaceExtension = {
    ...getDefaultErrorState(),
  },
  activeModspaceAddonLoaded:
    (state, payload: ActiveAddonExtension | null) => state.activeModspaceExtension = {
      status: MutationRequestStatus.SUCCESS,
      data: payload,
      error: undefined,
    },
};
